// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activity-frequency__label[data-v-218e25a6]{margin-top:24px;display:inline-block}", "",{"version":3,"sources":["webpack://./src/components/EmailSettings.vue"],"names":[],"mappings":"AACA,4CACC,eAAA,CACA,oBAAA","sourcesContent":["\n.activity-frequency__label {\n\tmargin-top: 24px;\n\tdisplay: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
